/**
 * @deprecated Use `IProcessedStyleSet` from `@fluentui/style-utilities` or `@fluentui/merge-styles` instead.
 */
export type IClassNames<T> = { [key in keyof T]: string };
